import React from "react";
import { Modal, Form, Button } from "react-bootstrap";
import EnvironmentUtils from "../../Utils/EnvironmentUtils";

const EditPreviewModal = ({ show, onHide, linkData }) => {
  if (!linkData) return null;

  const title = linkData.linkTitle || linkData.caption || linkData.slug || "";
  const description = linkData.shortSummaryDescription || linkData.description || "";

  // Prepare URL with correct domain for display and navigation
  const rawUrl = linkData.shortUrl || linkData.originalUrl || '';
  const displayUrl = EnvironmentUtils.updateDomainToThreadShare(rawUrl) || linkData.slug || '';
  const hrefUrl = EnvironmentUtils.getEnvironmentUrl(rawUrl) || displayUrl || '#';

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Link Preview</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="p-4">
        {/* Preview Section */}
        <div className="mb-4">
          <div
            className="border rounded p-4 text-start"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <h5 className="mb-2">{title || "Untitled"}</h5>
            <p className="mb-2 text-muted" style={{ fontSize: "0.9rem" }}>
              {description || "No description provided"}
            </p>
            <div className="d-flex align-items-center text-primary" style={{ fontSize: "0.85rem" }}>
              <i className="fas fa-external-link-alt me-1"></i>
              <a 
                href={hrefUrl}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-decoration-none text-primary"
                style={{ cursor: 'pointer' }}
              >
                {displayUrl}
              </a>
            </div>
          </div>
        </div>

        {/* Read-only Details */}
        <Form>
          <div className="border-top pt-3 mt-2">
            <h6 className="mb-3">Link Details</h6>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-2">
                  <Form.Label className="text-muted small">Created Date</Form.Label>
                  <Form.Control type="text" value={linkData.formattedDate || "N/A"} disabled size="sm" />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-2">
                  <Form.Label className="text-muted small">Original URL</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control type="text" value={linkData.originalUrl || linkData.shortUrl || "N/A"} disabled size="sm" className="me-2" />
                    {(linkData.originalUrl || linkData.shortUrl) && (
                      <a href={linkData.originalUrl || linkData.shortUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm" style={{ minWidth: '60px' }} title="Open link in new tab">
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    )}
                  </div>
                </Form.Group>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPreviewModal;
